export const GET_LOV_COLUMNS = 'GET_LOV_COLUMNS'
export const GET_LOV_LABELS = 'GET_LOV_LABELS'
export const GET_LOV_TITLE = 'GET_LOV_TITLE'
export const GET_LOV = 'GET_LOV'
export const RECEIVED_LOV_COLUMNS_LABELS = 'RECEIVED_LOV_COLUMNS_LABELS'
export const RECEIVED_LOV = 'RECEIVED_LOV'

export const SET_LOV_COLUMNS = 'SET_LOV_COLUMNS'
export const SET_LOV_LABELS = 'SET_LOV_LABELS'
export const SET_LOV_COLUMNS_LABELS_CALLED = 'SET_LOV_COLUMNS_LABELS_CALLED'

export const SET_LOV_CODEMPID = 'SET_LOV_CODEMPID'
export const SET_LOV_CODEMP9 = 'SET_LOV_CODEMP9'
export const SET_LOV_CODPOS = 'SET_LOV_CODPOS'
export const SET_LOV_CODAPP = 'SET_LOV_CODAPP'
export const SET_LOV_NUMMEMO = 'SET_LOV_NUMMEMO'
export const SET_LOV_CODCOURS = 'SET_LOV_CODCOURS'
export const SET_LOV_CODFORM = 'SET_LOV_CODFORM'
export const SET_LOV_NUMAPPL = 'SET_LOV_NUMAPPL'
export const SET_LOV_NUMREQ = 'SET_LOV_NUMREQ'
export const SET_LOV_APLV = 'SET_LOV_APLV'
export const SET_LOV_GRDSCOR = 'SET_LOV_GRDSCOR'
export const SET_LOV_CODAPPR = 'SET_LOV_CODAPPR'
export const SET_LOV_CODSHIFT = 'SET_LOV_CODSHIFT'
export const SET_LOV_CODROOM = 'SET_LOV_CODROOM'
export const SET_LOV_CODASSET = 'SET_LOV_CODASSET'

export const SET_LOV_CODCALEN = 'SET_LOV_CODCALEN'
export const SET_LOV_CODCOMPY = 'SET_LOV_CODCOMPY'
export const SET_LOV_BATCH = 'SET_LOV_BATCH'
export const GET_LOV_CURRENT_DESC = 'GET_LOV_CURRENT_DESC'
export const SET_LOV_COSTCENT = 'SET_LOV_COSTCENT'
export const SET_LOV_CODBRLC = 'SET_LOV_CODBRLC'
export const SET_LOV_CODTENCY = 'SET_LOV_CODTENCY'
export const SET_LOV_CODEDLV = 'SET_LOV_CODEDLV'
export const SET_LOV_CODJOB = 'SET_LOV_CODJOB'
export const SET_LOV_CODEMPMT = 'SET_LOV_CODEMPMT'
export const SET_LOV_TYPEMP = 'SET_LOV_TYPEMP'
export const SET_LOV_TYPPAYROLL = 'SET_LOV_TYPPAYROLL'
export const SET_LOV_CODINST = 'SET_LOV_CODINST'
export const SET_LOV_STAEMP = 'SET_LOV_STAEMP'
export const SET_LOV_CODDOMCL = 'SET_LOV_CODDOMCL'
export const SET_LOV_CODPROVR = 'SET_LOV_CODPROVR'
export const SET_LOV_GRDITEM = 'SET_LOV_GRDITEM'
export const SET_LOV_TYPLEAVE = 'SET_LOV_TYPLEAVE'
export const SET_LOV_COURSTRAIN = 'SET_LOV_COURSTRAIN'
export const SET_LOV_CODEMPSTAPP = 'SET_LOV_CODEMPSTAPP'



// WEBPACK FOOTER //
// ./src/store/modules/hrmsLov/mutation-types.js